import React from 'react';
import classnames from 'classnames';

import ODDS_FORMAT from '~/enums/odds_format';
import { useServicesContext } from '~/providers/services-context';
import BettingActions from '~/services/actions/betting-actions';
import useStore from '../../../../../../store';
import OCButton from '../../../../../button';

import { useLoaderContext } from '~/providers/loader-context';

import styles from './odds-format-dropdown.module.css';

const OddsFormatDropdown: React.FC = () => {
  const { DISABLE_ODDS_FORMAT_SELECTION } = useLoaderContext();

  const [oddsFormat, setOddsFormat] = useStore((state) => [
  state.oddsFormat,
  state.setOddsFormat]
  );
  const { labelActions } = useServicesContext();
  const bettingActions = React.useMemo(() => new BettingActions(), []);

  React.useEffect(() => {
    setOddsFormat(bettingActions.getOddsFormat());
  }, []);

  const changeFormat = (format: ODDS_FORMAT) => {
    bettingActions.changeOddsFormat(format);
    setOddsFormat(format);
    window.location.reload();
  };

  const renderFormats = (): JSX.Element => {
    const isAmerican = oddsFormat === ODDS_FORMAT.AMERICAN;
    const isDecimal = oddsFormat === ODDS_FORMAT.DECIMAL;
    const isFractional = oddsFormat === ODDS_FORMAT.FRACTIONAL;

    return (
      <div className={styles.formats}>
				<OCButton
          onClick={() => changeFormat(ODDS_FORMAT.AMERICAN)}
          className={classnames(
            styles.format,
            isAmerican ? styles.selected : ''
          )}
          disabled={isAmerican}>

					{ODDS_FORMAT.AMERICAN}
					<span className={styles.example}>+125</span>
				</OCButton>

				<OCButton
          onClick={() => changeFormat(ODDS_FORMAT.DECIMAL)}
          className={classnames(
            styles.format,
            isDecimal ? styles.selected : ''
          )}
          disabled={isDecimal}>

					{ODDS_FORMAT.DECIMAL}
					<span className={styles.example}>2.25</span>
				</OCButton>

				<OCButton
          onClick={() => changeFormat(ODDS_FORMAT.FRACTIONAL)}
          className={classnames(
            styles.format,
            isFractional ? styles.selected : ''
          )}
          disabled={isFractional}>

					{ODDS_FORMAT.FRACTIONAL}
					<span className={styles.example}>5/4</span>
				</OCButton>
			</div>);

  };

  if (DISABLE_ODDS_FORMAT_SELECTION) {
    return null;
  }
  return (
    <div data-testid="odds-format" className={styles.formatsContainer}>
			<div className={styles.cta}>
				{labelActions.get('ODDS_FORMAT')}
				<div className={styles.indicator}>&#x25BE;</div>
			</div>
			{renderFormats()}
		</div>);

};

export default OddsFormatDropdown;